// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonCard_container__8RLyM","content":"PersonCard_content__J8rNo","name":"PersonCard_name__25mFf","titles":"PersonCard_titles__Rhesd"};